(function ($) {
  Drupal.behaviors.fixedMenu = {

    attach: function (context) {
      $(window).scroll(function () {
        var fixedMenu = '#js_fixed-menu';
        var scrollTop = $(window).scrollTop();
        var scrollPoint = $(fixedMenu).attr('scroll-point');
        var maxScrollPoint = $(fixedMenu).attr('max-scroll-point');

        if (scrollTop > scrollPoint) {
          $(fixedMenu).addClass('filter-fixed-top');
        } else {
          $(fixedMenu).removeClass('filter-fixed-top');
        }
      });
    }
  };
})(jQuery);
